var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "group",
      class: { "with-error": _vm.error && !_vm.disabled },
      attrs: { loading: _vm.loading }
    },
    [
      _vm.error && !_vm.disabled
        ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "select",
        {
          attrs: { disabled: _vm.disabled || _vm.loading },
          domProps: { value: _vm.value },
          on: {
            input: function($event) {
              _vm.$emit("input", $event.target.value)
            }
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("label", { attrs: { active: _vm.isActive } }, [
        _vm._v(_vm._s(_vm.label))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bbc322a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bbc322a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_base/Select.vue
// module id = null
// module chunks = 